import Section from './CustomBlock'
import isEmpty from './CustomIsEmpty'

// no Options: HTML/CSS are now both edited via tabs directly in the block (#21821)
export default { isEmpty, Section }
